import {routes} from './projeto.routes';
import ProjetoListController from "./directory/directory.controller";
import ProjetoService from "./projeto.service";
import ProjetoDetailsController from "./details/details.controller";
import ProjetoCreateProjetoController from "./new/new.controller";
import ProjetoFileUploaderController from "./details/files.dialog.controller";

export default angular.module('app.projeto', [])
  .config(routes)
  .controller('ProjetoListController', ProjetoListController)
  .service('ProjetoService', ProjetoService)
  .controller('ProjetoDetailsController', ProjetoDetailsController)
  .controller('ProjetoCreateProjetoController', ProjetoCreateProjetoController)
  .controller('ProjetoFileUploaderController', ProjetoFileUploaderController)
  .name;
